/**
 * AP-32 Nachtrag 13 (N-105) — **Ein neuer Beleg ist vorläufig, bis er gespeichert wird.**
 *
 * Die Maske öffnet ihn als Entwurf ohne Nummer, der in keiner Liste steht. Verlässt sie ihn
 * ohne „Speichern", wird er verworfen. Was nicht mehr ankommt (Absturz, Netz weg), räumt der
 * Server nach einem Tag beim Lesen der Liste auf.
 */

import { api, getAccessToken } from '@/lib/axios'
import { documentsApi } from '../api/documents.api'

const geplant = new Map<string, ReturnType<typeof setTimeout>>()
const gespeichert = new Set<string>()

/**
 * Beim Verlassen der Maske — mit kurzer Frist: React montiert im Entwicklungsmodus sofort
 * wieder (StrictMode), und dann gehört der Beleg noch der Maske.
 */
export function verwirfSpaeter(id: string) {
  if (gespeichert.has(id)) return
  geplant.set(
    id,
    setTimeout(() => {
      geplant.delete(id)
      if (!gespeichert.has(id)) void documentsApi.discard(id).catch(() => undefined)
    }, 500),
  )
}

/** Die Maske hat den Beleg (wieder) geöffnet. */
export function behalteOffen(id: string) {
  const t = geplant.get(id)
  if (t) clearTimeout(t)
  geplant.delete(id)
}

/** Gespeichert oder schon verworfen — nichts mehr zu tun. */
export function erledigt(id: string) {
  behalteOffen(id)
  gespeichert.add(id)
}

/**
 * Tab geschlossen: Für eine Frist bleibt keine Zeit. `fetch` mit `keepalive` überlebt den
 * Seitenwechsel; `sendBeacon` kann keinen Authorization-Header setzen (wie `ui-settings.ts`).
 */
export function verwirfBeimSchliessen(id: string) {
  const token = getAccessToken()
  if (!token || gespeichert.has(id)) return
  try {
    void fetch(`${api.defaults.baseURL}/documents/${id}/provisional`, {
      method: 'DELETE',
      keepalive: true,
      credentials: 'include',
      headers: { Authorization: `Bearer ${token}` },
    })
  } catch {
    // Der Server räumt vorläufige Belege nach einem Tag selbst auf.
  }
}
